<template>
  <transition name="sliderUpHideRight">
    <div class="lenovobox_audio_vedio_mask" v-show="isShow" @click="close()">
      <div v-show="isShowVideo">
        <video controls="controls" autoplay="autoplay" :src="videoUrl" name="media" id="lenovobox_video_player" controlsList="nodownload"
               class="lenovobox_vedio">
          <source :src="videoUrl" type="video/mp4">
        </video>
      </div>
      <div v-show="isShowAudio">
        <audio id="lenovobox_audio_player" :src="audioUrl" controls="controls" autoplay="autoplay" controlsList="nodownload"
               class="lenovobox_audio">
          您的浏览器暂不支持播放该音频，请升级至最新版浏览器
        </audio>
      </div>
    </div>
  </transition>
</template>
<script>
  import * as Util from 'util'
  export default {
    props: {
      isStartPreview: {
        type: Boolean,
        required: true
      },
      datas: {
        type: Object
      }
    },
    data () {
      return {
        isShow: false,
        isShowAudio: false,
        isShowVideo: false,
        audioUrl: ``,
        videoUrl: ``,
        poster: `/static/logo.png`
      }
    },
    methods: {
      close () {
        this.isShow = false
        this.isShowAudio = false
        this.isShowVideo = false
        this.$emit('close')
      },
      preview () {
        let sessionID = Util.getSession()
        // http://172.16.22.226/v2/preview_router?type=av&root=databox&path=/%E9%9F%B3%E8%A7%86%E9%A2%91/test1.mp4&path_type=ent&from&neid=280&rev=63bfa369812448caa5a8e96a8504b73a
        // http://172.16.22.226:10095/file/databox/%E9%9F%B3%E8%A7%86%E9%A2%91/test1.mp4?X-LENOVO-SESS-ID=htu1tqaidtvevlg2u5366pmeu2&neid=280&path_type=ent&rev=63bfa369812448caa5a8e96a8504b73a
        let url = Util.getPreviewUrl(this.datas) + `&X-LENOVO-SESS-ID=` + sessionID + '&S=' + Util.getCookie('S')
        console.log(`url:` + url)
        if (Util.isAudio(this.datas.mime_type)) {
          this.isShowVideo = false
          this.isShowAudio = true
          this.audioUrl = url
          let timer = setTimeout(function () {
            let audio = document.getElementById(`lenovobox_audio_player`)
            console.log(`start play audio`)
            audio.play()
            clearTimeout(timer)
          }, 500)
        } else {
          this.isShowAudio = false
          this.isShowVideo = true
          this.videoUrl = url
          let timer = setTimeout(function () {
            let video = document.getElementById(`lenovobox_video_player`)
            console.log(`start play video`)
            video.play()
            clearTimeout(timer)
          }, 500)
        }
      }
    },
    computed: {},
    watch: {
      isStartPreview: function (val, oldVal) {
        console.log('isStartAudioVedioPreview:' + val)
        if (val === true) {
          this.isShow = true
          this.preview()
        }
      },
      isShowAudio: function (val, oldVal) {
        if (val === false) {
          var audio = document.getElementById(`lenovobox_audio_player`)
          audio.pause()
        }
      },
      isShowVideo: function (val, oldVal) {
        if (val === false) {
          let video = document.getElementById(`lenovobox_video_player`)
          video.pause()
        }
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .musicDetailCtrl
    height:12vh
    width:100%
    display:flex
    align-items:center
    justify-content:center
    font-size:0
    i
    display:inline-block
    font-size:28px
    width:20vw
    height:50px
    line-height:50px
    text-align:center
      &.playType,&.menu
        font-size:20px
        color:#e1e1e1
      &.playPause
        font-size:46px

  .lenovobox_audio_vedio_mask {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    opacity: 1;
    z-index: 11;
    background: rgba(0,0,0,0.5);
  }

  .lenovobox_audio {
    position: absolute;
    margin: -25% 0px 0px -45%;
    top: 50%;
    left: 50%;
    z-index: 10;
    width: 90%;
    height: 130px;
    opacity: 1;
    background: #fff;
    text-align: center;
    border-radius: 8px;
  }

  .lenovobox_vedio {
    position: absolute;
    margin: -25% 0px 0px -45%;
    top: 50%;
    left: 50%;
    z-index: 10;
    width: 90%;
    height: 330px;
    opacity: 1;
    background: #fff;
    text-align: center;
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// preview_audio_vedio.vue?382db494